import * as React from 'react'

import Stack from '@mui/material/Stack'
import { styled } from '@mui/material/styles'

import { I18n, useTranslation } from 'components/hooks/use-translation'
import { IconName } from 'components/atomic/atoms/icon/components/custom-icons'
import Icon from 'components/atomic/atoms/icon'
import Text from 'components/atomic/atoms/text'

const Feature = styled('div')`
    padding: 1rem;
    border-radius: ${({ theme }) => theme.shape.borderRadius}px;
    border: ${({ theme }) => `1px solid ${theme.palette.divider}`};
`

const Wrapper = styled('div')`
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(2, 1fr);
`

interface FeaturesGridProps {
    completionTime: string
    difficulty: string
    grantsCertificate: boolean
}

const FeaturesGrid = (props: FeaturesGridProps) => {
    const { t }: I18n = useTranslation()

    const features = React.useMemo((): { [key: string]: { icon: IconName; value: string } } => {
        return {
            time: {
                icon: 'timerOutlined',
                value: props.completionTime,
            },
            level: {
                icon: props.difficulty.toLowerCase() as IconName,
                value: t(`common:difficulty.${props.difficulty}`),
            },
            language: {
                icon: 'language',
                value: 'In italiano',
            },
        }
    }, [props, t])

    return (
        <Wrapper>
            {Object.keys(features).map((key) => {
                const item = features[key]
                return (
                    <Feature key={key}>
                        <Stack direction="row" spacing="1rem">
                            <Icon name={item.icon} />
                            <Text fontWeight="600">{item.value}</Text>
                        </Stack>
                    </Feature>
                )
            })}

            {props.grantsCertificate ? (
                <Feature>
                    <Stack direction="row" spacing="1rem">
                        <Icon name="medal" sx={{ color: '#ECD37C' }} />
                        <Text fontWeight="600" sx={{ color: '#ECD37C' }}>
                            {t('path:certificate')}
                        </Text>
                    </Stack>
                </Feature>
            ) : null}
        </Wrapper>
    )
}

export default FeaturesGrid
